var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 702,
    viewBox: "0 0 1440 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_760_1430",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 702
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V702H0V0Z",
    fill: "url(#paint0_linear_760_1430)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_760_1430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-753 702L0 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 702L954 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-276 702L477 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 702L1431 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-597 702L156 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 702L1110 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259 702L2012 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120 702L633 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834 702L1587 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 702L316 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 702L1270 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419 702L2172 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 702L793 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994 702L1747 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-673 702L80 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 702L1034 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183 702L1936 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-196 702L557 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 702L1511 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 702L236 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 702L1190 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339 702L2092 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 702L713 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 702L1667 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 702L396 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 702L1350 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 702L873 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 702L1827 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-717 702L36 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 702L990 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-240 702L513 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 702L1467 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-561 702L192 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 702L1146 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 702L2048 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 702L669 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 702L1623 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-401 702L352 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 702L1306 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 702L829 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 702L1783 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-637 702L116 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 702L1070 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219 702L1972 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-160 702L593 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 702L1547 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-481 702L272 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 702L1226 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 702L2128 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 702L749 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 702L1703 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-321 702L432 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 702L1386 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 702L909 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 702L1863 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-741 702L12 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 702L966 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-264 702L489 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 702L1443 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-585 702L168 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 702L1122 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271 702L2024 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108 702L645 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846 702L1599 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-425 702L328 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 702L1282 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431 702L2184 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 702L805 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006 702L1759 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-661 702L92 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 702L1046 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 702L1948 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-184 702L569 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 702L1523 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-505 702L248 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 702L1202 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351 702L2104 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28 702L725 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926 702L1679 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-345 702L408 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 702L1362 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 702L885 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086 702L1839 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-705 702L48 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 702L1002 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-228 702L525 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 702L1479 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 702L204 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 702L1158 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 702L2060 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72 702L681 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882 702L1635 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 702L364 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 702L1318 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 702L841 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 702L1795 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-625 702L128 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 702L1082 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231 702L1984 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-148 702L605 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 702L1559 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 702L284 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 702L1238 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387 702L2140 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 702L761 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962 702L1715 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 702L444 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 702L1398 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 702L921 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 702L1875 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-725 702L28 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 702L982 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-248 702L505 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706 702L1459 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-569 702L184 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 702L1138 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287 702L2040 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92 702L661 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862 702L1615 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-409 702L344 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 702L1298 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 702L821 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022 702L1775 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-645 702L108 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 702L1062 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211 702L1964 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-168 702L585 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786 702L1539 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-489 702L264 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 702L1218 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367 702L2120 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 702L741 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 702L1695 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-329 702L424 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 702L1378 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 702L901 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102 702L1855 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-689 702L64 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 702L1018 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167 702L1920 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-212 702L541 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 702L1495 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 702L220 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 702L1174 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323 702L2076 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56 702L697 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 702L1651 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 702L380 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 702L1334 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 702L857 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 702L1811 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-609 702L144 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 702L1098 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 702L2000 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-132 702L621 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 702L1575 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 702L300 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 702L1254 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 702L2156 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 702L777 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978 702L1731 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 702L460 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 702L1414 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 702L937 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138 702L1891 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-749 702L4 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 702L958 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-272 702L481 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 702L1435 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-593 702L160 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 702L1114 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263 702L2016 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116 702L637 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838 702L1591 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-433 702L320 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521 702L1274 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 702L2176 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 702L797 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998 702L1751 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-669 702L84 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 702L1038 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187 702L1940 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192 702L561 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762 702L1515 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-513 702L240 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 702L1194 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 702L2096 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 702L717 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 702L1671 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-353 702L400 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601 702L1354 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 702L877 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078 702L1831 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-713 702L40 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 702L994 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-236 702L517 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 702L1471 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 702L196 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 702L1150 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299 702L2052 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80 702L673 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874 702L1627 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 702L356 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 702L1310 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 702L833 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034 702L1787 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-633 702L120 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 702L1074 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223 702L1976 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156 702L597 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 702L1551 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 702L276 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 702L1230 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379 702L2132 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 702L753 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 702L1707 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 702L436 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 702L1390 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 702L913 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 702L1867 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-737 702L16 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 702L970 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-260 702L493 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 702L1447 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-581 702L172 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 702L1126 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275 702L2028 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104 702L649 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 702L1603 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 702L332 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 702L1286 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 702L2188 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 702L809 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 702L1763 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-657 702L96 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 702L1050 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199 702L1952 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180 702L573 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 702L1527 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 702L252 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 702L1206 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355 702L2108 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24 702L729 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 702L1683 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 702L412 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613 702L1366 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 702L889 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 702L1843 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-701 702L52 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 702L1006 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 702L1908 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224 702L529 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 702L1483 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-545 702L208 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 702L1162 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311 702L2064 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68 702L685 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886 702L1639 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-385 702L368 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 702L1322 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 702L845 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 702L1799 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-621 702L132 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 702L1086 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 702L1988 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144 702L609 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 702L1563 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-465 702L288 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 702L1242 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391 702L2144 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 702L765 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966 702L1719 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-305 702L448 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 702L1402 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 702L925 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126 702L1879 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-721 702L32 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 702L986 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244 702L509 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 702L1463 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-565 702L188 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 702L1142 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291 702L2044 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88 702L665 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866 702L1619 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 702L348 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 702L1302 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 702L825 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026 702L1779 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-641 702L112 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 702L1066 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215 702L1968 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164 702L589 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 702L1543 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 702L268 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 702L1222 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371 702L2124 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 702L745 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 702L1699 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 702L428 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 702L1382 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 702L905 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106 702L1859 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-685 702L68 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 702L1022 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171 702L1924 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-208 702L545 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 702L1499 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-529 702L224 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 702L1178 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327 702L2080 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52 702L701 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 702L1655 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-369 702L384 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 702L1338 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 702L861 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062 702L1815 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-605 702L148 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 702L1102 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251 702L2004 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 702L625 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 702L1579 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-449 702L304 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 702L1258 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407 702L2160 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 702L781 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982 702L1735 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-289 702L464 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 702L1418 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 702L941 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 702L1895 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-745 702L8 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 702L962 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-268 702L485 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 702L1439 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-589 702L164 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 702L1118 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267 702L2020 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112 702L641 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 702L1595 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 702L324 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 702L1278 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427 702L2180 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 702L801 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002 702L1755 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-665 702L88 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 702L1042 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 702L1944 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-188 702L565 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766 702L1519 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 702L244 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 702L1198 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347 702L2100 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 702L721 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 702L1675 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 702L404 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 702L1358 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 702L881 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082 702L1835 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-709 702L44 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 702L998 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-232 702L521 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 702L1475 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-553 702L200 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 702L1154 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 702L2056 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76 702L677 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 702L1631 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-393 702L360 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 702L1314 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 702L837 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038 702L1791 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-629 702L124 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 702L1078 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227 702L1980 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152 702L601 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802 702L1555 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-473 702L280 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 702L1234 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383 702L2136 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 702L757 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958 702L1711 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-313 702L440 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 702L1394 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 702L917 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118 702L1871 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-733 702L20 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 702L974 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-256 702L497 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 702L1451 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-577 702L176 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 702L1130 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279 702L2032 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100 702L653 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854 702L1607 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-417 702L336 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 702L1290 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 702L813 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 702L1767 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-653 702L100 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 702L1054 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203 702L1956 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-176 702L577 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778 702L1531 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-497 702L256 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457 702L1210 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359 702L2112 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 702L733 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934 702L1687 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-337 702L416 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 702L1370 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 702L893 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 702L1847 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-697 702L56 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 702L1010 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159 702L1912 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-220 702L533 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734 702L1487 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 702L212 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 702L1166 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315 702L2068 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 702L689 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 702L1643 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 702L372 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 702L1326 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 702L849 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 702L1803 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-617 702L136 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 702L1090 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239 702L1992 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140 702L613 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 702L1567 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 702L292 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 702L1246 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 702L2148 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 702L769 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 702L1723 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 702L452 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 702L1406 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 702L929 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 702L1883 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-717 702L36 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 702L990 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-240 702L513 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 702L1467 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-561 702L192 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 702L1146 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 702L2048 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84 702L669 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 702L1623 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-401 702L352 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 702L1306 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 702L829 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 702L1783 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-637 702L116 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 702L1070 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219 702L1972 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-160 702L593 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 702L1547 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-481 702L272 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 702L1226 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 702L2128 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 702L749 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 702L1703 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-321 702L432 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 702L1386 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 702L909 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 702L1863 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-681 702L72 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 702L1026 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 702L1928 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-204 702L549 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 702L1503 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 702L228 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 702L1182 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331 702L2084 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48 702L705 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906 702L1659 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 702L388 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 702L1342 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 702L865 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 702L1819 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-601 702L152 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 702L1106 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 702L2008 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124 702L629 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830 702L1583 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 702L308 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 702L1262 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411 702L2164 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 702L785 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 702L1739 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 702L468 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669 702L1422 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 702L945 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146 702L1899 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-741 702L12 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 702L966 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-264 702L489 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 702L1443 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-585 702L168 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 702L1122 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271 702L2024 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108 702L645 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846 702L1599 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-425 702L328 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 702L1282 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431 702L2184 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 702L805 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006 702L1759 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-661 702L92 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 702L1046 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 702L1948 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-184 702L569 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 702L1523 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-505 702L248 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 702L1202 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351 702L2104 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28 702L725 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926 702L1679 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-345 702L408 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 702L1362 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 702L885 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086 702L1839 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-705 702L48 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 702L1002 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-228 702L525 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 702L1479 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 702L204 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 702L1158 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 702L2060 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72 702L681 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882 702L1635 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 702L364 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 702L1318 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 702L841 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 702L1795 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-625 702L128 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 702L1082 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231 702L1984 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-148 702L605 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 702L1559 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 702L284 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 702L1238 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387 702L2140 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 702L761 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962 702L1715 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 702L444 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 702L1398 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 702L921 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 702L1875 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-729 702L24 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 702L978 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-252 702L501 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 702L1455 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-573 702L180 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 702L1134 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 702L2036 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96 702L657 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858 702L1611 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 702L340 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 702L1294 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 702L817 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018 702L1771 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-649 702L104 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 702L1058 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207 702L1960 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172 702L581 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782 702L1535 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 702L260 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 702L1214 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363 702L2116 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 702L737 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938 702L1691 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 702L420 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 702L1374 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 702L897 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098 702L1851 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-693 702L60 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 702L1014 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163 702L1916 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216 702L537 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 702L1491 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-537 702L216 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417 702L1170 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319 702L2072 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60 702L693 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 702L1647 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-377 702L376 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 702L1330 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 702L853 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054 702L1807 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-613 702L140 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 702L1094 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243 702L1996 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136 702L617 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 702L1571 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-457 702L296 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 702L1250 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399 702L2152 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 702L773 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 702L1727 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-297 702L456 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 702L1410 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 702L933 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134 702L1887 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-713 702L40 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 702L994 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-236 702L517 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 702L1471 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 702L196 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 702L1150 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299 702L2052 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80 702L673 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874 702L1627 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 702L356 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 702L1310 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 702L833 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034 702L1787 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-633 702L120 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 702L1074 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223 702L1976 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156 702L597 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 702L1551 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 702L276 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 702L1230 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379 702L2132 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 702L753 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 702L1707 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 702L436 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 702L1390 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 702L913 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 702L1867 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-677 702L76 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 702L1030 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179 702L1932 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-200 702L553 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754 702L1507 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-521 702L232 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 702L1186 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 702L2088 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 702L709 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 702L1663 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-361 702L392 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 702L1346 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 702L869 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 702L1823 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-597 702L156 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 702L1110 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259 702L2012 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120 702L633 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834 702L1587 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-441 702L312 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 702L1266 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 702L2168 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 702L789 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 702L1743 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-281 702L472 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 702L1426 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 702L949 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 702L1903 0",
    stroke: "#C01718",
    strokeOpacity: 0.04
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_760_1430",
    x1: 551.5,
    y1: 488.155,
    x2: 1266.55,
    y2: 421.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1A14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.280f194e91abccd2449c6f714cecef9f.svg";
export { ForwardRef as ReactComponent };